export const showMenuBtnStyles = {
  bottom: "16px",
  display: { xs: "flex", xl: "none" },
  position: "absolute",
  right: "16px",
  zIndex: 100,
};
